<template>
  <div>
    <media-radio-button
      class="multi_options"
      :value="value"
      @input="handleInput"
      id="endorsements"
      :options="options"
      :title="title"
      :color="color"
      name="endorsements"
      short-hand
      :multi-select="true"
    />

    <media-radio-button
      class="multi_options"
      @input="setNoEndorsements"
      :value="noEndorsementsSelected ? ['i do not have endorsements'] : []"
      :options="noEndorsementsOptions"
      :color="color"
      short-hand
      :multi-select="true"
    />
  </div>
</template>

<script>
import MediaRadioButton from '../../../components/MediaRadioButton.vue';

export default {
  components: { MediaRadioButton },
  emits: ['update'],

  props: {
    options: {
      required: true,
      type: Array,
    },
    value: {
      required: true,
    },
    color: {},
    title: {
      required: true,
      type: String,
    },
  },

  data: function () {
    return {
      noEndorsementsSelected: false,
      noEndorsementsOptions: [
        {
          label: 'I do not have endorsements',
          value: 'i do not have endorsements',
          short_hand: 'NONE',
        },
      ],
    };
  },

  watch: {
    value: function (newValue) {
      if (newValue.length > 0 && !newValue.includes('i do not have endorsements')) {
        this.noEndorsementsSelected = false;
      }
    },
  },

  methods: {
    handleInput(newValue) {
      // Remove 'i do not have endorsements' if it exists in the value
      const filteredValue = newValue.filter((val) => val !== 'i do not have endorsements');

      // Deselect 'noEndorsementsSelected' if other options are selected
      if (filteredValue.length > 0) {
        this.noEndorsementsSelected = false;
      }

      this.$emit('input', filteredValue);
    },

    setNoEndorsements() {
      this.noEndorsementsSelected = !this.noEndorsementsSelected;

      if (this.noEndorsementsSelected) {
        // Clear other options if "no endorsements" is selected
        this.$emit('input', ['i do not have endorsements']);
      } else {
        // Reset to empty if "no endorsements" is deselected
        this.$emit('input', []);
      }
    },
  },
};
</script>
